import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../data-storage.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-lang-switcher',
  templateUrl: './lang-switcher.component.html',
  styleUrls: ['./lang-switcher.component.scss']
})
export class LangSwitcherComponent implements OnInit {

  constructor(public dataStorageService: DataStorageService, private translate: TranslateService) {
  }

  ngOnInit() {
  }

  siwtchToEnglish() {
    this.dataStorageService.currentLanguage = 'en';
    this.translate.use(this.dataStorageService.currentLanguage);
  }

  siwtchToGerman() {
    this.dataStorageService.currentLanguage = 'de';
    this.translate.use(this.dataStorageService.currentLanguage);
  }

  siwtchToFrench() {
    this.dataStorageService.currentLanguage = 'fr';
    this.translate.use(this.dataStorageService.currentLanguage);
  }
}



// WEBPACK FOOTER //
// ./src/app/top-bar/lang-switcher/lang-switcher.component.ts